import { DatePipe } from "@angular/common";
import { Component, OnInit, ViewChild } from "@angular/core";
import { UntypedFormControl, UntypedFormGroup, Validators } from "@angular/forms";
import { MatSort } from "@angular/material/sort";
import { MatTableDataSource } from "@angular/material/table";
import { IDemographics } from "app/models/core/lab/demographics";
import { IProficiency } from "app/models/core/lab/proficiency";
import { ILabSpecialty } from "app/models/core/lab/specialty";
import { ISurvey } from "app/models/core/lab/surveys";
import { SharedService } from "app/services/core/shared.service";
import { LabService } from "app/services/lab/lab.service";
import { ReportsService } from "app/services/reports/reports.service";


@Component({
  selector: 'app-demographicsReport',
  templateUrl: './demographicsReport.component.html',
  styleUrls: ['./demographicsReport.component.scss'],
})

export class DemographicsReportComponent implements OnInit {

  reportMode = 'none';
  hideForPrinting = false;
  dateNow = '';
  dateNowYear = 0;


  demog: IDemographics = null;
  surveys: ISurvey[] = [];
  specialties: ILabSpecialty[] = [];
  proficiency: IProficiency[] = [];

  reportGroup = new UntypedFormGroup({
    StateNumber: new UntypedFormControl('', [Validators.required])
  });

  displayedColumns: string[] = ['surveyDate', 'surveyType', 'surveyors', 'conditionLevel', 'followUpDue',
    'followUpDone', 'onSiteFollowUp', 'deficiencies', 'hoursOnSite'
  ];
  dataSource = new MatTableDataSource<ISurvey>(this.surveys);
  @ViewChild('TableSort') sort: MatSort;

  displayedColumns2: string[] = ['specialty', 'tcd', 'subSpecialty', 'pt', 'volume',
    'opened', 'closed'
  ];
  dataSource2 = new MatTableDataSource<ILabSpecialty>(this.specialties);
  @ViewChild('TableSort') sort2: MatSort;

  displayedColumns3: string[] = ['specialty', 'subSpecialty', 'testCode', 'analyte', 'testId',
    'yyyy1', 'yyyy2', 'yyyy3', 'yyyy4', 'yyyy5', 'yyyy6'
  ];
  dataSource3 = new MatTableDataSource<IProficiency>(this.proficiency);
  @ViewChild('TableSort') sort3: MatSort;

  constructor(public reportsService: ReportsService,
    public sharedService: SharedService,
    public labService: LabService,
    private datePipe: DatePipe) { };

  ngOnInit(): void {
    this.reportMode = 'none';
    this.dateNow = this.datePipe.transform(new Date(), 'EEEE, MMMM dd, yyyy')
    this.dateNowYear = (new Date()).getFullYear();
  }

  runReport() {
    if (this.reportGroup.valid) {
      this.labService.getLab(this.reportGroup.controls['StateNumber'].value).subscribe(
        result => {
          this.demog = result;
          this.surveyList();

        },
        error => console.log('error', error),
        () => { }
      );
    }
  }

  printLabDemographics() {
    if (this.demog != null) {
      this.labService.printDemog(this.demog.stateNumber).subscribe(
        response => this.downloadFile("Demographics", response),
        error => console.log('error', error)
      );
    }
  }

  downloadFile(fileName: string, blob: Blob) {
    let file = URL.createObjectURL(blob);
    var fileDownload = document.createElement('a');
    fileDownload.href = file;
    fileDownload.download = fileName;
    fileDownload.click();
  }

  surveyList() {
    this.labService.getSurveys(this.demog.labId.toString()).subscribe(
      res => {
        this.surveys = res;
        this.dataSource.data = this.surveys;
        this.dataSource.sort = this.sort;

        this.demog.lastSurveyDate = this.surveys != null && this.surveys.length > 0 ? this.surveys[0].surveyDate : '';
        this.specialtyList();
        this.reportMode = 'list';
      },
      error => console.log('error: ', error),
      () => { }
    );
  }

  specialtyList(){
    this.labService.getLabSpecialtyList(this.demog.labId.toString()).subscribe(
      res => {
        this.specialties = res;
        this.dataSource2.data = this.specialties;
        this.dataSource2.sort = this.sort;

        this.proficiencyList();
      },
      error => console.log('error: ', error),
      () => { }
    );
  }

  proficiencyList(){
    this.labService.getProficiencyList(this.demog.stateNumber).subscribe(
      res => {
        this.proficiency = res;
        this.dataSource3.data = this.proficiency;
        this.dataSource3.sort = this.sort;
        this.reportMode = 'list';
        this.processMatrix(this.dateNowYear);
      },
      error => console.log('error: ', error),
      () => { }
    );
  }

  processMatrix(yr:number) {
    this.proficiency.forEach(function (results) {
      let yr1 = yr;
      let yr0 = yr - 1;
      results.yrResult0_1 = null;
      results.yrResult0_2 = null;
      results.yrResult0_3 = null;
      results.yrResult1_1 = null;
      results.yrResult1_2 = null;
      results.yrResult1_3 = null;
      results.labResults.forEach(function (val) {
        val.comments = val.comments == ''? null: val.comments;
        if (yr0 == val.year && val.period == '1') {
          results.yrResult0_1 = val;
        }
        if (yr0 == val.year && val.period == '2') {
          results.yrResult0_2 = val;
        }
        if (yr0 == val.year && val.period == '3') {
          results.yrResult0_3 = val;
        }
        if (yr1 == val.year && val.period == '1') {
          results.yrResult1_1 = val;
        }
        if (yr1 == val.year && val.period == '2') {
          results.yrResult1_2 = val;
        }
        if (yr1 == val.year && val.period == '3') {
          results.yrResult1_3 = val;
        }
      });
    });
  }

  removePrinterIcon(){
    //pdf.saveAs('Demographics.pdf');
  }

  timeout() {
    setTimeout(() => {
    }, 100);
  }

  print() {
    this.hideForPrinting = true;
    setTimeout(() => {
      window.print();
      setTimeout(() => {
        this.hideForPrinting = false;
      }, 2000);
    }, 250);

  }

  cancel(){
    this.reportMode = 'none';
  }

  tabVisible(type: string): boolean {
    // TODO
    return true;
  }

}
